import Link from 'next/link'
import { Box, Typography } from '@mui/material'
import { HIDDEN_WITH_BOTTOM_NAV } from './bottomNavStyles'

export type ProductSwitchTarget = 'prize-draws' | 'predictor'

const PRODUCT_BRAND: Record<ProductSwitchTarget, { label: string; logo: string; accent: string }> =
  {
    'prize-draws': {
      label: 'Prize Draws',
      logo: '/tbl_logo_prizedraws.png',
      accent: '#36E0F6',
    },
    predictor: {
      label: 'Predictor',
      logo: '/tbl_logo_predictor.png',
      accent: '#FCAD0E',
    },
  }

export interface ProductSwitchButtonProps {
  href: string
  product: ProductSwitchTarget
}

export const ProductSwitchButton = ({ href, product }: ProductSwitchButtonProps) => {
  const { label, logo, accent } = PRODUCT_BRAND[product]

  return (
    <Box
      component={Link}
      href={href}
      aria-label={`Try ${label}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 0, sm: 1 },
        pr: { xs: 0, sm: 1.75 },
        borderRadius: '999px',
        border: '1px solid rgba(255,255,255,0.3)',
        backgroundColor: 'rgba(50, 50, 50, 0.45)',
        backdropFilter: 'blur(6px)',
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        transition:
          'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease',
        '&:hover': {
          backgroundColor: 'rgba(96, 95, 95, 0.25)',
          borderColor: accent,
          boxShadow: `0 0 0 3px ${accent}33`,
          transform: 'translateY(-1px)',
        },
        '&:focus-visible': {
          borderColor: accent,
          boxShadow: `0 0 0 3px ${accent}66`,
        },
        ...HIDDEN_WITH_BOTTOM_NAV,
      }}
    >
      <Box
        sx={{
          width: '46px',
          height: '46px',
          flexShrink: 0,
          borderRadius: '50%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(50, 50, 50, 0.25)',
          p: '4px',
        }}
      >
        <Box
          component="img"
          src={logo}
          alt=""
          sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      </Box>
      <Typography
        sx={{
          display: { xs: 'none', sm: 'block' },
          color: 'white',
          fontWeight: 700,
          fontSize: '13px',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}
